export default __webpack_public_path__ + "static/media/Idle (10).291114e9.png";